export default __webpack_public_path__ + "static/media/loginImage.0af812c7.jpg";